import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/notification-center';

import 'css!./__styles__/NotificationListEmpty';

const NotificationListEmpty = () => (
  <div className="rc-NotificationListEmpty">
    <Typography2 variant="titleXSmall" component="h2">
      {_t('No notifications')}
    </Typography2>

    <div className="notification-list-empty-description">
      {_t("We'll let you know when deadlines are approaching, or there is a course update")}
    </div>
  </div>
);

export default NotificationListEmpty;
